import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { ArrowBack as ArrowBackIcon, ArrowForward as ArrowForwardIcon } from '@mui/icons-material';

import { getLanguageDirectionClass } from 'common/i18n/i18n';
import { CIButton } from 'common/viewcomp/forms/buttons';

interface Props {
    onClick: () => void;
}

export const BackButton = ({ onClick }: Props): ReactElement => {
    const { t } = useTranslation('auth');

    const languageDirectionClass = getLanguageDirectionClass();
    const isRTL = languageDirectionClass === 'isRTLLanguage';

    return (
        <div className="login-top-bar">
            <CIButton
                id="back-to-user-type"
                onClick={onClick}
                startIcon={isRTL ? <ArrowForwardIcon /> : <ArrowBackIcon />}
            >
                {t('common.back')}
            </CIButton>
        </div>
    );
};
